import { request } from '@kibt/krn-utils';
import { api, getEnv } from '@/common/api';
import { http } from '@/request';
import { isLogin } from '@/common/const';

// 加解密接口encryptionFormat所需要的参数配置

export const APPID = '1';
export const BIZ_TYPE = '1';
export const VERSION = '1';

export const getEncryptionFormat = (algorithm = 1) => {
    return {
        algorithm,
        appId: APPID,
        bizType: BIZ_TYPE,
        version: VERSION,
    };
};

/**
 * 查询AES加密参数
 */
export function getAesKey(params: { appId: string; bizType: string; version: string }) {
    return request.post(api('/rest/o/ecommerce/privacy/encryption/aes/param/query'), params);
}

let forge: any;
export async function getForge() {
    if (!forge) {
        const _forge = await import(/* webpackChunkName: "forge-lib" */ '@/common/utils/forgeLib');
        forge = _forge.default || _forge;
    }
    return forge;
}

export async function decodeByAes(iv: string, key: string, data: string) {
    const forge = await getForge();

    const decipher = forge.cipher.createDecipher('AES-CBC', forge.util.decode64(key));
    decipher.start({ iv });
    decipher.update(forge.util.createBuffer(forge.util.decode64(data)));
    const result = decipher.finish(); // check 'result' for true/false

    if (!result) {
        throw new Error('解密失败');
    }
    return decipher.output.toString();
}

export async function decodeData(
    data: string,
    options: {
        // 加密要用的算法 1: aes | 2: rsa
        algorithm: number;
        // 加密算法要用的参数，目前后端没要求，可以随便填
        appId: string;
        bizType: string;
        version: string;
    },
) {
    if (options.algorithm === 1) {
        // 获取秘钥
        const res = await getAesKey(options);
        const { iv, key } = res.data;
        // 解密
        return decodeByAes(iv, key, data);
    }
    throw new Error('not support');
}

export async function decodeDataV2(
    data: string,
    secretKey: {
        key: string; // AES秘钥
        iv: string; // 初始向量
    },
) {
    if (secretKey?.iv && secretKey?.key) {
        return decodeByAes(secretKey.iv, secretKey.key, data);
    }

    throw new Error('lack of aes params');
}

export async function getDecodeDataV2(content: any) {
    return JSON.parse(await decodeData(content, getEncryptionFormat()));
}

// 后端返回了密钥，少请求一次接口
export async function getDecodeDataV3(response: any) {
    const { content, secretKey } = response?.data || {};
    response.data = JSON.parse(await decodeDataV2(content, secretKey));
    return response;
}

export async function getDecodeData(response: any) {
    const content = response?.data?.content;
    const encryptionFormat = response?.data?.encryptionFormat;
    response.data = JSON.parse(await decodeData(content, encryptionFormat));
    return response;
}

/**
 * @function 查询用户收货地址
 */
export function postAddressQueryApiV2(params: { addressId?: number | null }) {
    return request
        .post(api('/rest/o/ecommerce/privacy/encrypt/customer/address/query'), {
            ...params,
            encryptionFormat: getEncryptionFormat(),
        })
        .then((res) => {
            if (!res?.data?.content) {
                return Promise.reject(res);
            }
            return getDecodeData(res);
        });
}

/**
 * @function 查询用户收货地址列表 deliveryAvailableParameters:这个用来给服务端那边判断是不是需要返回是否能配送的字段
 */
export function postAddressQueryApiV3(
    deliveryAvailableParameters: {
        merchantId: number;
        itemId: number;
        skuId: number;
    } | null,
) {
    // 未登录下不允许调用地址列表
    if (!isLogin && getEnv() !== 'dev') {
        return Promise.reject({
            code: 401,
            message: 'Not Login',
        });
    }
    const startTime = Date.now();
    return request
        .post(api('/rest/o/ecommerce/privacy/encrypt/customer/address/queryByUserId'), {
            deliveryAvailableParameters,
            encryptionFormat: getEncryptionFormat(),
        })
        .then((res) => {
            if (res.result === 1) {
                return getDecodeDataV3(res);
            } else {
                return Promise.reject(res);
            }
        })
        .finally(() => {
            console.log('address query api cost time:', Date.now() - startTime);
        });
}

export async function postSignalAddressQueryApi(addressId: number) {
    return http('POST/rest/o/ecommerce/privacy/encrypt/customer/address/queryByAddressId', {
        body: {
            addressId,
            encryptionFormat: getEncryptionFormat(),
        },
    }).then((res) => getDecodeDataV3(res));
}
